import LocationOnIcon from '@mui/icons-material/LocationOn';
import AcUnitIcon from '@mui/icons-material/AcUnit';
import { Box, Collapse, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

function EnabledRouteOrders({ showMore, pickupPoints, orders }) {
  const { t } = useTranslation(['glossary']);
  return (
    <Collapse in={showMore}>
      <Box>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
          <LocationOnIcon sx={{ color: 'action.active' }} />
          <Typography variant="body2" color="text.secondary" fontWeight="600">
            {t('pickup_points', { ns: 'glossary' })}
          </Typography>
        </Box>
        <Box sx={{ px: 3, my: 2 }}>
          {pickupPoints.map(({ id_warecloud, address }) => (
            <Typography key={id_warecloud} variant="body2" sx={{ mb: 1 }}>
              {address}
            </Typography>
          ))}
        </Box>

        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
          <LocationOnIcon sx={{ color: 'action.active' }} />
          <Typography variant="body2" color="text.secondary" fontWeight="600">
            {t('destinations', { ns: 'glossary' })}
          </Typography>
        </Box>
        <Box sx={{ px: 3, my: 2 }}>
          {orders.map(({ id_order, address, city, is_cold }) => (
            <Typography
              key={id_order}
              variant="body2"
              sx={{ mb: 1, display: 'flex', alignItems: 'center', gap: 1 }}
            >
              {address}, {city.city_name}
              {is_cold && (
                <AcUnitIcon sx={{ fontSize: 18, color: 'info.main' }} />
              )}
            </Typography>
          ))}
        </Box>
      </Box>
    </Collapse>
  );
}

export default EnabledRouteOrders;
